/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: newsletter-webapp-contrib
 * Version: 7.2.0-BETA-0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    $.extend($.fn.dataTable.defaults.oLanguage, {
        "sProcessing": "Traitement en cours&hellip;",
        "sSearch": "Filtrer",
        "sLengthMenu": "Afficher _MENU_ éléments",
        "sInfo": "Éléments _START_ à _END_ sur _TOTAL_",
        "sInfoEmpty": "",
        "sInfoFiltered": "(filtré de _MAX_ éléments au total)",
        "sInfoPostFix": "&nbsp;",
        "sLoadingRecords": "Chargement en cours&hellip;",
        "sZeroRecords": "Aucun élément à afficher",
        "sEmptyTable": "Aucune donnée disponible dans le tableau",
        "oPaginate": {
            "sFirst": "Premier",
            "sPrevious": "Précédent",
            "sNext": "Suivant",
            "sLast": "Dernier"
        },
        "oAria": {
            "sSortAscending": ": activer pour trier la colonne par ordre croissant",
            "sSortDescending": ": activer pour trier la colonne par ordre décroissant"
        }
    });
})(jQuery);